import axios from 'axios';

export default {
  list: async sitePath => {
    const url = `${sitePath}/qcentro/`;
    const response = await axios.get(url);
    return response.data;
  },

  delete: async (sitePath, id) => {
    const url = `${sitePath}/qcentro/${id}/`;
    const response = await axios.delete(url);
    return response.data;
  },

  get: async (sitePath) => {
    const url = `${sitePath}/qcentro/`;
    const response = await axios.get(url);
    return response.data;
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/qcentro/`;
    const response = await axios.post(url, data);
    return response.data;
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/qcentro/${id}/`;
    const response = await axios.put(url, data);
    return response.data;
  },

  list_process_matrix: async (sitePath) => {
    const url = `${sitePath}/qcentro/list_process_matrix`;
    const response = await axios.get(url);
    return response.data;
  },

  add_process: async (sitePath, id, process_id) => {
    const url = `${sitePath}/qcentro/${id}/add_process/`;
    const data = new FormData();
    data.append('process_id', process_id);
    const response = await axios.put(url, data);
    return response.data;
  },

  remove_process: async (sitePath, id, process_id) => {
    const url = `${sitePath}/qcentro/${id}/remove_process/`;
    const data = new FormData();
    data.append('process_id', process_id);
    const response = await axios.put(url, data);
    return response.data;
  },

  centro_roles: async (sitePath, id) => {
    const url = `${sitePath}/qcentro/${id}/centro_roles/`;
    const response = await axios.get(url);
    return response.data;
  },

  modify_user_roles: async (sitePath, id, user_id, role_ids) => {
    const url = `${sitePath}/qcentro/${id}/modify_user_roles/`;
    const data = new FormData();
    data.append('user_id', user_id);
    data.append('roles_ids', role_ids);
    const response = await axios.put(url, data);
    return response.data;
  },

  add_user_role: async (sitePath, id, user_id, role_id) => {
    const url = `${sitePath}/qcentro/${id}/add_user_role/`;
    const data = new FormData();
    data.append('user_id', user_id);
    data.append('role_id', role_id);
    const response = await axios.put(url, data);
    return response.data;
  },

  remove_user_role: async (sitePath, id, user_id, role_id) => {
    const url = `${sitePath}/qcentro/${id}/remove_user_role/`;
    const data = new FormData();
    data.append('user_id', user_id);
    data.append('role_id', role_id);
    const response = await axios.put(url, data);
    return response.data;
  },

  url_name_to_path: async (url_name) => {
    const url = `centropath/?url_name=${url_name}`;
    const response = await axios.get(url);
    return response.data;
  },

  list_manager_candidates: async(site_id, centro_id) => {
    const url = `${site_id}/qcentro/${centro_id}/list_manager_candidates`;
    const response = await axios.get(url);
    return response.data;
  },

  set_user_manager: async (site_id, centro_id, user_id, manager_state) => {
    const url = `${site_id}/qcentro/${centro_id}/set_user_manager/`;
    const data = new FormData();
    data.append('user_id', user_id);
    data.append('manager', (manager_state ? 1 : 0));
    const response = await axios.put(url, data);
    return response.data;
  },
};
